<template>
  <div class="question-view">
    <div class="quest">
      <div class="title">
        <vue-mathjax :formula="form.title" @onRenderComplete="mathjaxRes" :safe="false"/>
      </div>
      <div class="sum-region">
        <!-- 加减乘 -->
        <div class="canvas" v-if="equation.sumType != '/'">
          <div class="num-item" v-for="(its, idx) in numList" :key="idx">
            <!-- 运算符 -->
            <span class="symbol" v-if="idx == (numList.length == 3 ? 1 : 2 )">{{ symbol[equation.sumType] }}</span>

            <!-- 數字 -->
            <div class="num-block" v-for="(item, index) in its" :key="index">
              <span class="empty" v-if="item == '#'"></span>
              <span class="num" v-else-if="item != ''">{{ item }}</span>
              <input type="text" :data-idx="`${idx},${index}`" v-else class="fill" id="" @change="getNumList($event)">
            </div>
          </div>
        </div>

        <!-- 除 -->
        <div class="division" v-else>
          <div class="divisor">
            <div class="num-block" v-for="(item, idx) in numList.divisor" :key="idx">
              <span class="empty" v-if="item == '#'"></span>
              <span class="num" v-else-if="item != ''">{{ item }}</span>
              <input type="text" :data-idx="`divisor,${idx}`" v-else class="fill" id="" @change="getNumList($event)">
            </div>
          </div>

          <div class="discuss">
            <div class="single" v-for="(its, idx) in numList.list" :key="idx">
              <!-- 样式 -->
              <div class="division-style" v-if="idx == 0"></div>
              <div class="num-block" v-for="(item, index) in its" :key="index">
                <span class="empty" v-if="item == '#'"></span>
                <span class="num" v-else-if="item != ''">{{ item }}</span>
                <input type="text" :data-idx="`list,${idx},${index}`" v-else class="fill" id="" @change="getNumList($event)">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import division from './division'
import changeSunType from './handleSum'

export default {
  props: ['form'],
  data() {
    return {
      symbol: {
        '+': '➕',
        '-': '➖',
        '*': '✖️',
        '/': '➗',
      },

      image: '',
      topic: '',
      equation: {},

      /**
       * 填空列表 
       * equation.sumType != division
       * 加减乘
       * [
       *   ['2', '3', '4', '1', '2'],
       *   ['#', '2', '3', '4', '1'],
       *   ['2', '5', '7', '5', '3'], 
       * ]
       * 
       * equation.sumType == division
       * 除
       * {
       *    divisor: ['2'],
       *    list: [
       *      ['#', '6', '2'],
       *      ['1', '2', '4'],
       *      ['1', '2', '#'],
       *      ['#', '#', '4'],
       *      ['#', '#', '4'],
       *      ['#', '#', '0'],
       *    ]
       * }
       */
      // 填空列表 加减乘
      numList: [],
      // 答案列表
      correctList: []
    }
  },
  methods: {
    mathjaxRes() {
      // console.log('算术题')
      this.$emit('onRenderComplete')
    },
    // getNumList(e) {
    //   let dom = e.target
    //   // console.log(dom.dataset.idx, ' -- ',  dom.value)
    // },
    // 处理加减乘 數据
    handleSum(numList) {
      let numListCopy = [],
      correctListCopy = []

      // 处理列式數据
      numList.filter((its, idx) => {
        numListCopy[idx] = []
        correctListCopy[idx] = []

        its.filter((item, index) => {
          correctListCopy[idx][index] = item.num
          
          if(item.check) numListCopy[idx][index] = ''
          else numListCopy[idx][index] = item.num
        })
      })

      this.numList = numListCopy
      this.correctList = correctListCopy
    },
    // 处理除 數据
    handleDivision({divisor, list}) {
      let numListCopy = {divisor: [], list: []},
      correctListCopy = {divisor: [], list: []}

      // 处理列式數据
      divisor.filter(item => {
        correctListCopy.divisor.push(item.num)

        if(item.check) numListCopy.divisor.push('')
        else numListCopy.divisor.push(item.num)
      })

      list.filter((its, idx) => {
        numListCopy.list[idx] = []
        correctListCopy.list[idx] = []

        its.filter((item, index) => {
          correctListCopy.list[idx][index] = item.num
          
          if(item.check) numListCopy.list[idx][index] = ''
          else numListCopy.list[idx][index] = item.num
        })
      })

      this.numList = numListCopy
      this.correctList = correctListCopy
    },
    handleEquation(equation, letter) {
      let {first_input, second_input, result, third_input, operator} = equation
      , randomNum, num1, num2, num3, num4
      // first_input
      if(first_input.type == 0) {
        let [s, e] = first_input.range.split(',')
        , end = Math.max(s, e)
        , start = Math.min(s, e)
        num1 = Math.floor(Math.random() * (end - start + 1)) + start * 1
      } else if(first_input.type == 2) randomNum = 1
      else num1 = first_input.value
      
      // second_input
      if(second_input.type == 0) {
        let [s, e] = second_input.range.split(',')
        , end = Math.max(s, e)
        , start = Math.min(s, e)
        num2 = Math.floor(Math.random() * (end - start + 1)) + start * 1
      } else if(second_input.type == 2) randomNum = 2
      else num2 = second_input.value
      
      // third_input
      if(third_input != undefined && third_input.type == 0) {
        let [s, e] = third_input.range.split(',')
        , end = Math.max(s, e)
        , start = Math.min(s, e)
        num3 = Math.floor(Math.random() * (end - start + 1)) + start * 1
      } else if(third_input != undefined && third_input.type == 2) randomNum = 3
      else if(third_input != undefined) num3 = third_input.value

      // result
      if(result.type == 0) {
        let [s, e] = result.range.split(',')
        , end = Math.max(s, e)
        , start = Math.min(s, e)
        num4 = Math.floor(Math.random() * (end - start + 1)) + start * 1
      } else if(result.type == 2) randomNum = third_input != undefined ? 4 : 3
      else num4 = result.value

      if(randomNum == 1) {
        switch(operator) {
          case '+' : num1 = num4 - num2 - (num3 || 0) ;break
          case '-' : num1 = Number(num2) + Number(num4) + Number(num3 || 0) ;break
          case '*' : num1 = num4 / num2 / (num3 || 1);break
          case '/' : num1 = num4 * num2 ;break
        }
        num1 != Math.floor(num1) && this.handleEquation(equation, letter)
      } else if(randomNum == 2) {
        switch(operator) {
          case '+' : num2 = num4 - num1 - (num3 || 0) ;break
          case '-' : num2 = Number(num1) - Number(num4) - Number(num3 || 0) ;break
          case '*' : num2 = num4 / num1 / (num3 || 1) ;break
          case '/' : num2 = num4 * num1 ;break
        }
        num2 != Math.floor(num2) && this.handleEquation(equation, letter)
      } else if(randomNum == 3) {
        if(third_input != undefined) {
          // 目前只处理 加法
          switch(operator) {
            case '+' : num3 = num4 - Number(num1) - Number(num2) ;break
            case '-' : num3 = num1 - num2 - num4;break
            case '*' : num3 = num4 / num1 / num2  ;break
            case '/' : num3 = num1 / num2 ;break
          }
          num3 != Math.floor(num3) && this.handleEquation(equation, letter)
        } else {
          switch(operator) {
            case '+' : num4 = Number(num1) + Number(num2) + Number(num3 || 0);break
            case '-' : num4 = num1 - num2 - Number(num3 || 0) ;break
            case '*' : num4 = num1 * num2 * (num3 || 1);break
            case '/' : num4 = num1 / num2 ;break
          }
          num4 != Math.floor(num4) && this.handleEquation(equation, letter)
        }
      } else if(randomNum == 4) {
        switch(operator) {
          case '+' : num4 = Number(num1) + Number(num2) + Number(num3 || 0);break
          case '-' : num4 = num1 - num2 - Number(num3 || 0) ;break
          case '*' : num4 = num1 * num2 * Number(num3 || 0) ;break
          case '/' : num4 = num1 / num2 ;break
        }
        num4 != Math.floor(num4) && this.handleEquation(equation, letter)
      }

      switch(randomNum) {
        case 1:  
          num1 = String(num1).split('').map(() => {
            return letter.splice(0, 1)[0]
          }).join('')
          break
        case 2:  
          num2 = String(num2).split('').map(() => {
            return letter.splice(0, 1)[0]
          }).join('')
          break
        case 3:  
          if(third_input != undefined) {
            num3 = String(num3).split('').map(() => {
              return letter.splice(0, 1)[0]
            }).join('')
            break
          } else {
            num4 = String(num4).split('').map(() => {
              return letter.splice(0, 1)[0]
            }).join('')
            break
          }
        case 4:  
          num4 = String(num4).split('').map(() => {
            return letter.splice(0, 1)[0]
          }).join('')
          break
      }

      let resultData = {num1, num2, num4, sumType: operator}
      if(num3 != undefined) resultData.num3 = num3
      return resultData
    }
  },
  created() {
    let regex = /\(\)/g,
    letter = new Array(62).fill().map((its, idx) => its = String.fromCharCode(65 + idx)),
    tempSum = {}

    let content = JSON.parse(this.form.content.split('-------')[0]),
    answers = JSON.parse(JSON.stringify(this.form.answers)),
    copyCte = {
      num1: content.first_input,
      num2: content.second_input,
      num3: content.third_input,
      num4: content.result,
      sumType: content.operator
    }

    if(this.form.type == 3) {
      let num1 = content.first_input.match(regex)
      let num2 = content.second_input.match(regex)
      let num3 = content.third_input && content.third_input.match(regex)
      let num4 = content.result.match(regex)
      
      num2 && num2.filter(its => {
        // 区分除法与 加减乘
        if(copyCte.sumType == '/') {
          copyCte.num2 = copyCte.num2.replace(its, `(${answers[0].value})`)
        } else {
          copyCte.num2 = copyCte.num2.replace(its, letter[0])
          tempSum[letter[0]] = answers[0].value
          letter.splice(0, 1)
        }
        answers.splice(0, 1)
      })
  
      num3 && num3.filter(its => {
        // 区分除法与 加减乘
        if(copyCte.sumType == '/') {
          copyCte.num3 = copyCte.num3.replace(its, `(${answers[0].value})`)
        } else {
          copyCte.num3 = copyCte.num3.replace(its, letter[0])
          tempSum[letter[0]] = answers[0].value
          letter.splice(0, 1)
        }
        answers.splice(0, 1)
      })

      num4 && num4.filter(its => {
        // 区分除法与 加减乘
        if(copyCte.sumType == '/') {
          copyCte.num4 = copyCte.num4.replace(its, `(${answers[0].value})`)
        } else {
          copyCte.num4 = copyCte.num4.replace(its, letter[0])
          tempSum[letter[0]] = answers[0].value
          letter.splice(0, 1)
        }
        answers.splice(0, 1)
      })

      num1 && num1.filter(its => {
        // 区分除法与 加减乘
        if(copyCte.sumType == '/') {
          copyCte.num1 = copyCte.num1.replace(its, `(${answers[0].value})`)
        } else {
          copyCte.num1 = copyCte.num1.replace(its, letter[0])
          tempSum[letter[0]] = answers[0].value
          letter.splice(0, 1)
        }
        
        answers.splice(0, 1)
      })
    } else if(this.form.type == 8) {
      copyCte = this.handleEquation(content, letter)
    }

    // console.log(copyCte)
    let numList = changeSunType(copyCte)
    this.equation = {...copyCte}
    
    if(copyCte.sumType == '/') this.handleDivision(numList)
    else this.handleSum(numList)
    // console.log(copyCte)
  },
  mounted() {
    
  }
}
</script>

<style scoped lang="scss">
.question-view {
  width: 100%;
  height: 100%;
  padding: 20px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-radius: 10px; 
  
  .quest {
    width: 100%;
    height: 100%;

    .title {
      font-size: 18px;
      color: #333;
    }

    .sum-region {
      margin-top: 20px;

      $block: 40px;
      $size: 18px;
      $margin: 5px;

      .num, .empty {
        width: $block;
        height: $block;
        box-sizing: border-box;
        border-radius: 3px;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: $margin;
        font-size: $size;
      }
      .fill {
        width: $block;
        height: $block;
        box-sizing: border-box;
        min-width: auto;
        border-radius: 3px;
        outline: none;
        background-color: #fcd2ab;
        border: none;
        text-align: center;
        font-size: $size;
        padding: 0;
        margin-left: $margin;
      }
      .canvas {
        padding: 10px;
        box-sizing: border-box;
        
        .num-item {
          width: fit-content;
          padding-left: $block;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-bottom: $margin;

          .symbol {
            width: $block;
            height: $block;
            box-sizing: border-box;
            border-radius: 3px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: $margin;
            font-size: $size;
          }

          .num:hover {
            // background-color: #fcd2ab;
          }
        }
        .num-item:nth-last-of-type(2) {
          margin-bottom: 10px;
          position: relative;

          &:before {
            content: '';
            position: absolute;
            width: 102%;
            height: 1px;
            background-color: #333;
            bottom: -5px;
            left: 0;
          }

          .symbol {
            position: absolute;
            border: none;
            left: 0;
            top: 0;
            margin: 0;
            cursor: default;
          }
        }
      }
      .division {
        display: flex;
        align-content: flex-start;
        margin-top: 20px;

        .divisor {
          width: fit-content;
          height: 2 * $block;
          display: flex;
          align-items: flex-end;
          margin-right: 20px;
          margin-top: $margin;
        }
        .discuss {
          width: fit-content;
          .single {
            width: fit-content;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            margin-bottom: $margin;
          }

          .single:nth-of-type(2n - 1) {
            position: relative;
            
            &:before {
              content: '';
              position: absolute;
              bottom: calc($margin / -2);
              left: 0;
              width: 100%;
              height: 1px;
              background-color: #333;
            }
          }

          .division-style {
            position: absolute;
            width: 20px;
            height: 50px;
            top: calc(100% + $margin / 2);
            left: -20px;
            overflow: hidden;

            &:before {
              content: '';
              position: absolute;
              border-radius: 50%;
              box-sizing: border-box;
              top: -80px;
              left: -60px;
              width: 80px;
              height: 160px;
              border: 1px solid #333;
              border: none;
              border-right: 1px solid #333;
              border-bottom: 1px solid #333;
            }
          }
        }
      }
    }
  }
}
</style>